import { TimeRangeTupleTs, useGraphCtx } from '@mi-front/core';
import { TimeBrush } from '@mi-front/ui';
import { useCallback } from 'react';
import { useFocus, useSetFocus } from '../../stores/stream-screen.store';
import { PREVIEW_MIN_SELECTION_LENGTH } from './config';

type BrushEventHandler = (range: TimeRangeTupleTs, isResizing: boolean) => void;

export const PreviewBrush = () => {
  const focus = useFocus();
  const setFocus = useSetFocus();
  const minSelectionLength = PREVIEW_MIN_SELECTION_LENGTH;

  const onBrushEvent: BrushEventHandler = useCallback(
    (range) => {
      setFocus({
        from: range[0],
        to: range[1],
      });
    },
    [setFocus],
  );

  const { width, height, scale } = useGraphCtx();

  return (
    <TimeBrush
      key={height}
      selectionRange={{
        from: focus.from,
        to: focus.to,
      }}
      minSelectionLength={minSelectionLength}
      onStart={onBrushEvent}
      onChange={onBrushEvent}
      onEnd={onBrushEvent}
      scale={scale}
      parentWidth={width}
      parentHeight={height}
    />
  );
};
